import { SimpleSearchFilter } from 'api/dashboard/widget';
import { CustomReportExportRequest } from 'components/pages/custom-reports/types';

export enum ExportStatusType {
  TaskExport = 'TASK_LIST_EXPORT',
  ProjectExport = 'PROJECT_LIST_EXPORT',
  TimesheetReportExport = 'TIMESHEET_REPORT_EXPORT',
  CustomReportExport = 'CUSTOM_REPORTS_EXPORT',
}
export interface FilterBy {
  match: string | null;
  projectId?: number;
  [key: string]: unknown;
}
export interface ExportRequest {
  filterBy: FilterBy;
  columnOrder?: string[];
}
export interface TimesheetExportRequest {
  startDate: string;
  endDate: string;
  match: string;
  [key: string]: unknown;
}

export interface StatusMeta {
  request: ExportRequest | TimesheetExportRequest | CustomReportExportRequest;
  filter?: SimpleSearchFilter;
}
export interface ExportPayload {
  statusType: ExportStatusType;
  statusMeta: StatusMeta;
}
export enum ExportQueueStatus {
  Submitted = 'SUBMITTED',
  InProgress = 'IN_PROGRESS',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
}
export interface ExportResponse {
  statusId: number;
  createdAt: number;
  status: ExportQueueStatus;
  statusMeta: StatusMeta;
}
